export enum MainSettingsEnum {
  LocalLabel = 'localLabel',
  CountyLabel = 'countyLabel',
  SameAdress = 'sameAddress',
  AssSelectorType = 'assSelectorType',
  ShowMyAssociation = 'showMyAssociation',
  ShowMyDistrict = 'showMyDistrict',
  UseDigitalMembercard = 'useDigitalMembercard',
  Currency = 'currency',
  MemberGridCustomCols = 'memberGridCustomCols',
  MemberGridHideDistrict = 'memberGridHideDistrict',
  MemberGridHideAssociation = 'memberGridHideAssociation',
  OtherLabelPlural = 'otherLabelPlural',
  OtherLabel = 'otherLabel',
  UseOther = 'useOther',
  // Modulinställningen chkUseNewFriend i 1.0. Styr om avgiften för vänmedlem visas.
  UseNewFriend = 'useNewFriend',
  // Benämning 'Nya vänmedlem' i samma 1.0-vy. Standard är Vänmedlem.
  NewFriendLabel = 'newFriendLabel',
}
